import React, { useEffect, useState } from "react";
import { VIP_DISCORD_TICKET_URL } from "@/components/vip-simulator/vipInvoiceExport";
import { isValidSteamId, normalizeSteamId } from "@/lib/steamId";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * @param {{
 *   initialValue?: string;
 *   saving?: boolean;
 *   onSave: (steamId: string) => Promise<{ ok: boolean; error?: string }>;
 *   compact?: boolean;
 * }} props
 */
export default function SteamIdForm({ initialValue = "", saving = false, onSave, compact = false }) {
    const { t } = useI18n();
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState("");

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!isValidSteamId(value)) {
            setError(t("auth.steam.invalidInput"));
            return;
        }
        const result = await onSave(normalizeSteamId(value));
        if (!result.ok) {
            setError(result.error || t("auth.steam.saveFailed"));
        }
    };

    return (
        <form
            className={`zrs-steam-form ${compact ? "zrs-steam-form--compact" : ""}`}
            onSubmit={handleSubmit}
        >
            <label className="zrs-steam-form__label" htmlFor="zrs-steam-id">
                SteamID64 <span className="zrs-steam-form__req">*</span>
            </label>
            <p className="zrs-steam-form__hint">
                {t("auth.steam.hint")}
            </p>
            <input
                id="zrs-steam-id"
                className="zrs-steam-form__input"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="76561198012345678"
                inputMode="numeric"
                autoComplete="off"
                required
                aria-invalid={Boolean(error)}
            />
            {error ? (
                <p className="zrs-steam-form__error" role="alert">
                    {error}
                </p>
            ) : null}
            <p className="zrs-steam-notice">
                {t("auth.steam.verifyNotice")}{" "}
                <a href={VIP_DISCORD_TICKET_URL} target="_blank" rel="noopener noreferrer">
                    {t("auth.steam.discordTicket")}
                </a>
                .
            </p>
            <button type="submit" className="zrs-steam-form__btn" disabled={saving}>
                {saving ? t("auth.steam.saving") : t("auth.steam.save")}
            </button>
        </form>
    );
}
